import PropTypes from "prop-types";
import React from "react";

class MediaPhoto extends React.Component {
  render() {
    const mediaBg = {
      backgroundImage: "url(" + this.props.media + ")"
    };

    return <div className="media-photo" style={mediaBg} />;
  }
}

MediaPhoto.propTypes = {
  media: PropTypes.string
};

export default MediaPhoto;
